import React, { useEffect, useState } from 'react'
import { Button, Image, Layout } from 'antd'
import { useHistory } from 'react-router-dom'
import { ArrowLeftOutlined } from '@ant-design/icons'
import './course.less'
import SearchBar from 'components/SearchBar'
import RedirectCardCom from 'components/RedirectCard'

const { Sider, Content } = Layout

// 课程页面
const AiToolInfoCom = () => {
  const history = useHistory()

  // 当前课程
  const state: any = history.location.state
  const tool = state.resource
  const [loginCardVisible, setVisible] = useState(false)

  const courseBack = () => {
    history.goBack()
  }

  const toAiToolWeb = (url: string) => {
    setVisible(true)
  }

  return (
    <>
      <div style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/resource-banner.png)` }}>
        <SearchBar module="AI Tools" />
      </div>
      <div className="layout-content-mask">
        <div className="layout-content-bg-LB"></div>
        <div className="layout-content-bg-RT"></div>
        <div className="course-container" style={{ paddingBottom: 45 }}>
          <div
            className="course-container-header"
            onClick={courseBack}
          >
            <ArrowLeftOutlined />
            <div className="second-title course-container-header-text">返回</div>
          </div>
          <Layout className="course-desc-layout" style={{ height: 300, padding: 30 }}>
            <Sider width={300} theme="light" className="course-container-sider">
              <div
                className="resource-card-image"
                style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/${tool.image})`, backgroundSize: "cover", backgroundPosition: "center", width: "100%", height: "100%" }}
              ></div>
            </Sider>
            <Content className="course-desc-content" key="desc-content">
              {/* 标题 */}
              <div className="course-desc-content-header">
                <div className="title bold" style={{ color: '#40A9FF' }}>
                  {tool.name}
                </div>
              </div>
              {/* 介绍 */}
              <div className="course-desc-text-group">
                <div className="course-desc-text">{tool.desc}</div>
              </div>
              <Button type="primary" onClick={() => toAiToolWeb(tool.url)}>链接直达</Button>
              {/* 标签 */}
              <div className="course-tag-list-group">
                {tool.tag}
              </div>
            </Content>
          </Layout>

          {/* 详细信息 */}
          <div className="title bold" style={{ color: '#262626', marginBottom: 16 }}>
            详细信息
          </div>
          <div style={{ whiteSpace: 'pre-wrap' }}>{tool.info}</div>
          <RedirectCardCom loginCardVisible={loginCardVisible} url={tool.url} setVisible={setVisible} />
        </div>
      </div>
    </>
  )
}

export default AiToolInfoCom
